<a *ngFor="let item of $socialMedia | async" class="social-media-link " [href]="item.link" target="_blank">
  <i class="social-media-link__icon icon-glyph-{{item.type}}"></i>
</a>
